import {
  Box,
  Button,
  CircularProgress,
  Modal,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { toTwoDecimals } from "../../../components/NewDetail/calculations/utils";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const QuoteRow = ({ onSelect, order, isPendingQuote = false }) => {
  const theme = useTheme();
  const [loadingInvoice, setIsLoadingInvoice] = useState(false);
  const { authToken, ezorder } = useContext(AuthContext);
  const [invoice, setInvoice] = useState(null);
  const navigate = useNavigate();

  // TODO: query backend to query QB for invoice details
  const getInvoiceDetails = async (controller) => {
    try {
      setIsLoadingInvoice(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(
        `/admin/orders/${order.id}/invoice`,
        data
      );

      setInvoice(response.data.invoice);
    } catch (error) {
      console.log("Failed To Load Invoice for Order", order.id);
    } finally {
      setIsLoadingInvoice(false);
    }
  };

  useEffect(() => {
    // console.log("OrderTableRow useEffect()");
    const controller = new AbortController();
    if (
      (order !== null || order !== undefined) &&
      order.invoiceId &&
      !isPendingQuote
    ) {
      // console.log("Invoice ID found for Order: ", order.name);

      getInvoiceDetails(controller);
    }

    return () => {
      controller.abort(); // abort api call on unmount for cleanup
    };
  }, [order]);

  return (
    <TableRow hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell align="left">
        <Button
          size="small"
          variant="outlined"
          sx={{ borderRadius: "25px" }}
          color={
            order.orderStatus.name == "QUOTE_REQUESTED"
              ? "warning" // "Draft"
              : order.orderStatus.name == "ESTIMATE_APPROVAL_NEEDED"
              ? "info" // "Sent"
              : order.orderStatus.name == "CANCELLED"
              ? "error" // "Cancelled"
              : // All Other Status is "Sold"
                "success" //"Sold"
          }
        >
          {order.orderStatus.name == "QUOTE_REQUESTED"
            ? `Draft${order.isNewEstimateRequested ? " (RENEW)" : ""}`
            : order.orderStatus.name == "ESTIMATE_APPROVAL_NEEDED"
            ? "Sent"
            : order.orderStatus.name == "CANCELLED"
            ? "Cancelled"
            : // All Other Status is "Sold"
              "Sold"}
        </Button>
      </TableCell>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        <Box
          sx={{
            minWidth: "100px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
          }}
        >
          {order.salesRep
            ? `${order.salesRep.fullName}${
                order.salesRep.deletedAt ? " [DEACTIVATED]" : ""
              }`
            : "UNASSIGNED"}
        </Box>
      </TableCell>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        {order.id}
      </TableCell>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        <Box
          sx={{
            minWidth: "120px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
          }}
        >
          {order.company && order.company.name ? order.company.name : "GUEST"}
        </Box>
      </TableCell>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        <Box
          sx={{
            minWidth: "120px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
          }}
        >
          {order.project && order.project.name ? order.project.name : "N/A"}
        </Box>
      </TableCell>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        <Box
          sx={{
            minWidth: "100px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
          }}
        >
          {order.poNumber}
        </Box>
      </TableCell>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        {moment(order.createdAt).format("MM/DD/YY")}
      </TableCell>
      {isPendingQuote && (
        <TableCell
          align="left"
          onClick={() => {
            onSelect(order);
          }}
        >
          {order.estimateLastSentForApproval
            ? moment(order.estimateLastSentForApproval).format("MM/DD/YY")
            : "N/A"}
        </TableCell>
      )}
      {!isPendingQuote && (
        <TableCell
          align="left"
          onClick={() => {
            onSelect(order);
          }}
        >
          {loadingInvoice ? (
            <CircularProgress sx={{ margin: "4px" }} />
          ) : (
            <Typography sx={{ textAlign: "right" }}>
              {invoice ? `$${invoice.Balance}` : "N/A"}
            </Typography>
          )}
        </TableCell>
      )}
      {!isPendingQuote && (
        <TableCell
          align="left"
          onClick={() => {
            onSelect(order);
          }}
        >
          {loadingInvoice ? (
            <CircularProgress sx={{ margin: "4px" }} />
          ) : (
            <Typography sx={{ textAlign: "right" }}>
              {invoice
                ? `${moment(invoice.DueDate).format("MM/DD/YY")}`
                : "N/A"}
            </Typography>
          )}
        </TableCell>
      )}

      <TableCell align="left">
        {order.outTheDoorCost !== undefined &&
        order.outTheDoorCost !== null &&
        order.estimatePdf
          ? `$${Math.round(Number(order.outTheDoorCost ?? 0))}`
          : `---`}
      </TableCell>
    </TableRow>
  );
};

export default QuoteRow;
